import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Badge,
  Button,
  Card,
  Grid,
  ODataTable,
  Tabs,
  Heading,
  Panel,
  Formatter,
  InfoTooltip,
  Snackbar,
} from 'framework-ui-components';
import SuccessIcon from 'framework-ui-components/Components/Icons/SuccessIcon';
import DownloadIcon from 'framework-ui-components/Components/Icons/DownloadIcon';
import AlertIcon from 'framework-ui-components/Components/Icons/AlertIcon';
import PageWrapper from '../../components/PageWrapper';
import RoundProgress from '../../components/RoundProgress';
import PieChart from '../../components/PieChart';
import EventoServer from '../../libs/EventoServer';
import RigaDettaglioOperazione from './RigaDettaglioOperazione';
import {
  contatoriDettagli,
  elaborazioneMassiva,
  risultatoDisponibile,
} from '../../apis/elaborazioniMassiveApi';
import throttle from '../../helpers/throttle';

class DettaglioOperazione extends Component {
  constructor(props) {
    super(props);
    this.state = {
      idElaborazione: props.match.params.id,
      stati: {},
      Servizio: '',
      Operazione: '',
      Esito: null,
      IndicaRiferimenti: false,
      Indeterminata: false,
      Totale: 0,
      InEsecuzione: false,
      Elaborati: 0,
      DataInizio: null,
      DataFine: null,
      OperazioniAggiuntive: null,
      DettagliAggiuntivi: null,
      UrlRisultato: null,
      DescrizioneUrlRisultato: null,
      RisultatoDisponibile: null,
      downloading: false,
    };

    this.initializeComponent();
  }

  componentWillMount() {
    const { ufficioSelezionato } = this.props;
    this.caricaContatori(ufficioSelezionato.CodiceUfficio);
  }

  componentDidMount() {
    EventoServer.subscribe('ElaborazioneMassivaAvanzata', this.ricarica);
    EventoServer.subscribe('ElaborazioneMassivaCompletata', this.ricarica);
  }

  componentWillReceiveProps(nextProps) {
    const { ufficioSelezionato } = this.props;

    if (ufficioSelezionato.CodiceUfficio !== nextProps.ufficioSelezionato.CodiceUfficio) {
      this.caricaContatori(nextProps.ufficioSelezionato.CodiceUfficio);
    }
  }

  componentWillUnmount() {
    EventoServer.unsubscribe('ElaborazioneMassivaAvanzata', this.ricarica);
    EventoServer.unsubscribe('ElaborazioneMassivaCompletata', this.ricarica);
  }

  initializeComponent = () => {
    this.caricaContatori = this.caricaContatori.bind(this);
    this.ricarica = throttle(this.ricarica.bind(this), 5000);
  }

  caricaContatori = (studio) => {
    const { idElaborazione } = this.state;
    contatoriDettagli(studio, idElaborazione).then((x) => {
      this.setState({ stati: x });
    });
    elaborazioneMassiva(idElaborazione).then((x) => {
      if (x && x.UrlRisultato) {
        risultatoDisponibile(idElaborazione, studio).then(r => this.setState(r));
      } else {
        x.RisultatoDisponibile = false;
      }
      this.setState(x);
    });
  }

  ricarica = () => {
    const { ufficioSelezionato: { CodiceUfficio } } = this.props;
    this.caricaContatori(CodiceUfficio);
    this.tabellaDichiarazioni.loadPage();
  }

  downloadRisultato = () => {
    const { UrlRisultato, idElaborazione } = this.state;
    const { ufficioSelezionato } = this.props;
    if (UrlRisultato) {
      window.location = `/ElaborazioniMassive/DownloadRisultato?codiceUfficio=${
        ufficioSelezionato.CodiceUfficio
      }&id=${idElaborazione}`;
      /*
      const { ufficioSelezionato: { CodiceUfficio } } = this.props;
      const { idElaborazione } = this.state;
      this.setState({ downloading: true }, () => {
        getDownloadRisultato(idElaborazione, CodiceUfficio)
          .then((response) => {
            const fileName = WebRequest.getFileNameFromGetFileResponse(response) || 'Report.xls';
            saveAs(response.data, fileName);
            this.setState({ downloading: false });
          });
      });
      */
    }
  };

  showError = (errore) => {
    Snackbar.show({
      type: Snackbar.Types.ERROR,
      message: errore || 'Si è verificato un errore durante il download',
    });
  };

  render() {
    const { ufficioSelezionato } = this.props;
    const {
      stati,
      InEsecuzione,
      Totale,
      Elaborati,
      Servizio,
      Operazione,
      DataInizio,
      DataFine,
      Indeterminata,
      OperazioniAggiuntive,
      DettagliAggiuntivi,
      Esito,
      DescrizioneUrlRisultato,
      UrlRisultato,
      RisultatoDisponibile,
      downloading,
      idElaborazione,
      IndicaRiferimenti,
    } = this.state;

    const operazioni = JSON.parse(OperazioniAggiuntive) || [];
    const dettagli = JSON.parse(DettagliAggiuntivi) || [];
    const badgeConteggio = count => (count !== 0 ? <Badge info>{count}</Badge> : null);
    const badgeAlarmConteggio = count => (count !== 0 ? <Badge alarm>{count}</Badge> : null);

    return (
      <PageWrapper
        helmetTitle="Monitoraggio elaborazioni"
        pageTitle={`${Servizio} -  ${Operazione}`}
        pageBack
      >
        <Grid fluid className="pl-0 pr-0 elab-massiva">
          <Grid.Row>
            <Grid.Col md="12">
              <Card title="Elementi Elaborati" className="table--filters-15">
                <Grid fluid>
                  <Grid.Row>
                    <Grid.Col md="3">
                      <Heading as="h5">Stato Elaborazione:</Heading>
                      <Heading as="h3" className="stato-elaborazione">
                        <span className="progress-icon">
                          {InEsecuzione && !Indeterminata && (
                            <RoundProgress percentuale={Math.floor((Elaborati / Totale) * 100)} />
                          )}
                          {!InEsecuzione && (
                            <span className="badgeInfo">
                              <SuccessIcon />
                            </span>
                          )}
                        </span>
                        <span className="progress-elaborazione">
                          {!Indeterminata && InEsecuzione && (
                            <span> {Math.floor((Elaborati / Totale) * 100)} % - </span>
                          )}
                          {InEsecuzione ? 'In corso' : 'Terminata'}
                        </span>
                      </Heading>
                      {!Indeterminata && (
                        <span>
                          Elementi Elaborati:{' '}
                          {InEsecuzione ? (
                            <span>
                              {Elaborati} di {Totale}
                            </span>
                          ) : (
                            <span>{Totale}</span>
                          )}
                          <br />
                          <br />
                        </span>
                      )}
                      Inizio Elaborazione:{' '}
                      {DataInizio && (
                        <span>
                          <Formatter tipo="date" valore={DataInizio} /> -{' '}
                          <Formatter tipo="hour" valore={DataInizio} /> <br />
                        </span>
                      )}
                      {DataFine && (
                        <span>
                          {' '}
                          Fine Elaborazione: <Formatter tipo="date" valore={DataFine} /> -{' '}
                          <Formatter tipo="hour" valore={DataFine} />
                          <br />
                        </span>
                      )}
                      {RisultatoDisponibile !== null && (
                        <span>
                          {UrlRisultato && RisultatoDisponibile && DescrizioneUrlRisultato && (
                            <span>
                              <Button
                                primary
                                text
                                loading={downloading}
                                className="noEffects downloadLink"
                                onClick={this.downloadRisultato}
                              >
                                <DownloadIcon /> {DescrizioneUrlRisultato}
                              </Button>
                            </span>
                          )}
                          {!UrlRisultato && DescrizioneUrlRisultato && (
                            <span className="noDownloadLink error">
                              <span className="badgeAlert">
                                <AlertIcon />
                              </span>
                              {DescrizioneUrlRisultato}
                            </span>
                          )}
                          {UrlRisultato && !RisultatoDisponibile && (
                            <span className="noDownloadLink warning">
                              <span className="badgeWarning">
                                <AlertIcon />
                              </span>
                              {"L'esito non è più disponibile "}
                              <InfoTooltip>
                            I documenti generati restano disponibili al download per un periodo di
                            tempo limitato. Effettua una nuova elaborazione per ottenere un nuovo
                            risultato.
                              </InfoTooltip>
                            </span>
                          )}
                        </span>
                      )}
                    </Grid.Col>
                    <Grid.Col md="3">
                      {!InEsecuzione && (
                        <div>
                          <Heading as="h5">
                            Esito elaborazione {Esito && <InfoTooltip>{Esito}</InfoTooltip>}
                          </Heading>
                          <PieChart totale={Totale} errori={stati.Negativo} />
                        </div>
                      )}
                    </Grid.Col>
                    <Grid.Col md="6">
                      {(operazioni.length > 0 || dettagli.length > 0) && (
                        <Panel info className="pannelloElaborazioniMassive">
                          <Heading as="h5">Dettagli elaborazione</Heading>
                          {operazioni.length > 0 && (
                            <div className="operazioneAggiuntiva">
                              {operazioni.length > 0 && (
                                <Heading as="h6">Operazioni aggiuntive eseguite</Heading>
                              )}
                              {operazioni.map((x, j) => (
                                <span className="">
                                  {x.Descrizione} <b>{x.Numero}</b>{' '}
                                  {x.Dettagli && (
                                    <span>
                                      (di cui{' '}
                                      {x.Dettagli.map((z, i) => (
                                        <span>
                                          {z.Descrizione} <b>{z.Numero}</b>
                                          {i + 1 < x.Dettagli.length && <span>, </span>}
                                        </span>
                                      ))}
                                      )
                                    </span>
                                  )}
                                  {j + 1 < operazioni.length && <span> - </span>}
                                </span>
                              ))}
                              {operazioni.length > 0 && <span>.</span>}
                            </div>
                          )}

                          {dettagli.length > 0 && (
                            <span>
                              {dettagli.map((x, j) => (
                                <div className="dettaglioAggiuntivo">
                                  <Heading as="h6">{x.Descrizione}</Heading>
                                  <span className="">
                                    {x.Dettagli
                                      && x.Dettagli.map((z, i) => (
                                        <span>
                                          {z}
                                          {i + 1 < x.Dettagli.length && <span> - </span>}
                                        </span>
                                      ))}
                                    {x.Dettagli.length > 0 && <span>. </span>}
                                  </span>
                                </div>
                              ))}
                            </span>
                          )}
                        </Panel>
                      )}
                    </Grid.Col>
                  </Grid.Row>
                </Grid>
                <br />
                <br />
                <Tabs initialIndex={0}>
                  <Tabs.Tab title={<span>Tutti {badgeConteggio(stati.Totale)}</span>}>
                    <ODataTable
                      ref={(r) => { this.tabellaDichiarazioni = r; }}
                      hover
                      clickable
                      url={`/ElaborazioniMassive/TuttiDettagli?codiceUfficio=${
                        ufficioSelezionato.CodiceUfficio
                      }&id=${idElaborazione}`}
                      row={RigaDettaglioOperazione}
                      pageSize={10}
                      availablePageSizes={[10, 20, 50]}
                      additionalRowData={{ IndicaRiferimenti }}
                    >
                      <ODataTable.Column propertyName="Descrizione">Descrizione</ODataTable.Column>
                      <ODataTable.Column propertyName="Successo">Esito</ODataTable.Column>
                      <ODataTable.Column propertyName="Nota">Nota Esito</ODataTable.Column>
                      {IndicaRiferimenti && (
                        <ODataTable.Column propertyName="Riferimento">
                          Riferimento Esito
                        </ODataTable.Column>
                      )}
                    </ODataTable>
                  </Tabs.Tab>

                  <Tabs.Tab title={<span>Esito positivo {badgeConteggio(stati.Positivo)}</span>}>
                    <ODataTable
                      ref={(r) => { this.tabellaDichiarazioni = r; }}
                      hover
                      clickable
                      url={`/ElaborazioniMassive/DettagliPositivi?codiceUfficio=${
                        ufficioSelezionato.CodiceUfficio
                      }&id=${idElaborazione}`}
                      row={RigaDettaglioOperazione}
                      pageSize={10}
                      availablePageSizes={[10, 20, 50]}
                      additionalRowData={{ IndicaRiferimenti }}
                    >
                      <ODataTable.Column propertyName="Descrizione">Descrizione</ODataTable.Column>
                      <ODataTable.Column propertyName="Successo">Esito</ODataTable.Column>
                      <ODataTable.Column propertyName="Nota">Nota Esito</ODataTable.Column>
                      {IndicaRiferimenti && (
                        <ODataTable.Column propertyName="Riferimento">
                          Riferimento Esito
                        </ODataTable.Column>
                      )}
                    </ODataTable>
                  </Tabs.Tab>

                  <Tabs.Tab
                    title={<span>Esito negativo {badgeAlarmConteggio(stati.Negativo)}</span>}
                  >
                    <ODataTable
                      ref={(r) => { this.tabellaDichiarazioni = r; }}
                      hover
                      clickable
                      url={`/ElaborazioniMassive/DettagliNegativi?codiceUfficio=${
                        ufficioSelezionato.CodiceUfficio
                      }&id=${idElaborazione}`}
                      row={RigaDettaglioOperazione}
                      pageSize={10}
                      availablePageSizes={[10, 20, 50]}
                      additionalRowData={{ IndicaRiferimenti }}
                    >
                      <ODataTable.Column propertyName="Descrizione">Descrizione</ODataTable.Column>
                      <ODataTable.Column propertyName="Successo">Esito</ODataTable.Column>
                      <ODataTable.Column propertyName="Nota">Nota Esito</ODataTable.Column>
                      {IndicaRiferimenti && (
                        <ODataTable.Column propertyName="Riferimento">
                          Riferimento Esito
                        </ODataTable.Column>
                      )}
                    </ODataTable>
                  </Tabs.Tab>
                </Tabs>
              </Card>
            </Grid.Col>
          </Grid.Row>
        </Grid>
      </PageWrapper>
    );
  }
}

const mapStoreToProps = store => ({
  ufficioSelezionato: store.utente.ufficioSelezionato,
});

DettaglioOperazione.propTypes = {
  ufficioSelezionato: PropTypes.shape({
    CodiceUfficio: PropTypes.string,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
};

export default connect(mapStoreToProps)(DettaglioOperazione);
